<ul class="my-5 text-center" style="list-style:none">
  <li class=" py-3"><a target="_blank" href="/assets/flyers/Jazz Night.pdf">Jazz Night - 7pm on October 15th 2022</a>
  </li>
  <li class=" py-3"><a target="_blank" href="/assets/flyers/The First 100 Years A4 Poster.pdf">The First 100 Years - 3pm to 6pm on October 16th 2022</a>
  </li>
</ul>
